import React from 'react';
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import CheckoutFormSignup from './CheckoutFormSignup'; 
export default class Signup extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            stripePromise :loadStripe("pk_test_51I71o3KD8YUugTD1p18N7Kpq3RbEB05nTMGXkDTSQQYDMLcta9gO1rHGjIchv2qEF43QX0XnxC3mKZ01SgoJubO100F6VmFPbB")
        };  
    } 
  
    render() {
        return (
            <Elements stripe={this.state.stripePromise} >
                <CheckoutFormSignup />
            </Elements>
        )}
}
